import React, { type PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Banner, { BANNER_COLOR_DANGER, BannerType } from '@divvy-web/skylab.banner'

import styles from './styles.module.scss'

const ReviewSectionsErrorFallbackBanner = () => {
  const [getClassName, makeTestId] = useNameFormatter('ReviewSectionsErrorFallbackBanner')

  return (
    <div className={styles[getClassName('')]}>
      <Banner
        backgroundColor={BANNER_COLOR_DANGER}
        bannerType={BannerType.Error}
        dataTestId={makeTestId('banner')}
        messageContent={
          <FormattedMessage
            defaultMessage="We couldn't load your application details. Please refresh the page and try again."
            id='sputnik.ReviewSectionsErrorBoundary__nRxHfx'
          />
        }
      />
    </div>
  )
}

const ReviewSectionsErrorBoundary = ({ children }: PropsWithChildren) => (
  <ErrorBoundary FallbackComponent={ReviewSectionsErrorFallbackBanner}>{children}</ErrorBoundary>
)

export default ReviewSectionsErrorBoundary
